import { formatArray } from "./formatArray";

export function GetFieldLink(fieldDef, dataObj, hasLabel) {
  if (dataObj == null) return "";

  if (Array.isArray(dataObj)) {
    var contentArr = [];
    for (var aDataObjIdx in dataObj) {
      var datObj = dataObj[aDataObjIdx];
      var content = datObj.GetFieldValue(fieldDef);
      contentArr.push(content);
    }
    contentArr = contentArr.filter(function (value, index, array) {
      return array.indexOf(value) === index && value !== "";
    });
    return formatArray(contentArr);
  }
  var v = dataObj.GetFieldValue(fieldDef);
  if (v == null) return "";

  if (hasLabel) {
    var s = v.split("|");
    var v = s.length > 1 ? s[1] : s[0];
  }

  return v;
}
